module.exports = __webpack_public_path__ + "media/images/icons/flags/SR-1054d7e5db8b598e2b6cbb5cefa081d7.svg";